<!-- 2 columns form -->
<form name="ekubform" [formGroup]="ekubForm" novalidate>
  <div class="panel panel-flat">
    <div class="panel-heading">
      <h5 class="panel-title">Add Equb</h5>
      <div class="heading-elements">
        <ul class="icons-list">
          <li>
            <a data-action="reload" ng-click="mainService.reload()"></a>
          </li>
        </ul>
      </div>
      <hr class="divider">
    </div>

    <div class="panel-body">

      <div class="row">
        <div class="col-md-5">
          <fieldset>
            <legend class="text-semibold">
              <i class="icon-reading position-left"></i> Equb Details <span *ngIf="ekub.ekub_id">-
                <b>{{ekub?.ekub_id}}</b></span>
            </legend>

            <!--  <div *ngIf="operation!='add'" class="form-group required">
              <span class="control-label"> EkubID: </span>
              <input type="text" name="name" required formControlName="name" class="form-control"
                placeholder="ekub title">
              <div class="help-block" *ngIf="name.invalid && (name.dirty || name.touched)">
                <p class="text-danger">
                  <i class="icon-cancel-circle2 position-left text-red"></i> Ekub title is required
                </p>
              </div>
            </div> -->

            <div class="row">
              <div class="col-md-6">
                <div class="form-group required">
                  <span class="control-label"> Category: </span>
                  <ng-select [items]="categories" placeholder="" formControlName="category" bindLabel="title" required
                    (change)="calculate()">
                  </ng-select>
                  <!-- <br />
                  <br /> Selected values: {{ value }} -->

                  <div class="help-block" *ngIf="category.invalid && (category.dirty || category.touched)">
                    <p class="text-danger">
                      <i class="icon-cancel-circle2 position-left"></i> You must select equb category
                    </p>
                  </div>
                </div>
              </div>

              <div class="col-md-6">
                <div class="form-group required">
                  <span class="control-label"> Total Members: </span><br><br>
                  <input type="number" name="total_members" required formControlName="total_members"
                    placeholder="Total members" class="form-control" (change)="calculate()">
                  <div class="help-block"
                    *ngIf="total_members.invalid && (total_members.dirty || total_members.touched)">
                    <p class="text-danger" *ngIf="total_members.errors.required">
                      <i class="icon-cancel-circle2 position-left"></i> total equb members is required
                    </p>
                    <p class="text-danger" *ngIf="total_members.errors.min">
                      <i class="icon-cancel-circle2 position-left"></i> must be greater than 0
                    </p>
                  </div>
                </div>
              </div>





            </div>


            <div class="row">

              <div class="col-md-4">
                <div class="form-group required">
                  <span class="control-label">First Awards: </span>
                  <input type="number" name="first_awards" required formControlName="first_awards"
                    placeholder="First awards count" class="form-control" (change)="calculate()">
                  <div class="help-block" *ngIf="first_awards.invalid && (first_awards.dirty || first_awards.touched)">
                    <p class="text-danger">
                      <i class="icon-cancel-circle2 position-left"></i> First Awards Count is required
                    </p>
                  </div>
                </div>
              </div>

              <div class="col-md-4">
                <div class="form-group required">
                  <span class="control-label">First Award On: </span>
                  <input type="number" name="first_award_on" required formControlName="first_award_on"
                    placeholder="First award on" class="form-control" (change)="calculate()">
                  <div class="help-block"
                    *ngIf="first_award_on.invalid && (first_award_on.dirty || first_award_on.touched)">
                    <p class="text-danger">
                      <i class="icon-cancel-circle2 position-left"></i> First Award on is required
                    </p>
                  </div>
                </div>
              </div>


              <div class="col-md-4">
                <div class="form-group required">
                  <span class="control-label">Qualification Threshold: </span>
                  <input type="number" name="qualification_threshold" required formControlName="qualification_threshold"
                    placeholder="Minimum for equb award qualification" class="form-control">
                  <div class="help-block"
                    *ngIf="qualification_threshold.invalid && (qualification_threshold.dirty || qualification_threshold.touched)">
                    <p class="text-danger">
                      <i class="icon-cancel-circle2 position-left"></i> Equb Qualification Threshold is required
                    </p>
                  </div>
                </div>
              </div>

              <div class="col-md-4">
                <div class="form-group required">
                  <span class="control-label">Estimated Start Date: </span>
                  <input type="date" name="start_date" formControlName="start_date" placeholder="equb start date"
                    class="form-control" (change)="calculateEndDate()">
                </div>
              </div>

              <div class="col-md-4">
                <div class="form-group required">
                  <span class="control-label">Estimated End Date: </span>
                  <input type="date" name="end_date" formControlName="end_date" placeholder="equb estimated end date"
                    class="form-control">
                </div>
              </div>

              <div class="col-md-4">
                <div class="form-group required">
                  <span class="control-label">Service Charge (%): </span>
                  <input type="number" name="service_charge" formControlName="service_charge"
                    placeholder="equb service charge in %" class="form-control">
                </div>
              </div>

              <div class="col-md-4">
                <div class="form-group required">
                  <span class="control-label"> Length:
                    <!-- <span
                      *ngIf="category">{{getInterval(category.value.interval)}}</span> -->
                  </span>
                  <input type="number" name="length" formControlName="length"
                    placeholder="Minimum amount before completion" class="form-control" required>
                  <div class="help-block" *ngIf="length.invalid && (length.dirty || length.touched)">
                    <p class="text-danger">
                      <i class="icon-cancel-circle2 tx-red position-left"></i> Equb Length is required
                    </p>
                  </div>
                </div>
              </div>

              <div class="col-md-4">
                <div class="form-group required">
                  <span class="control-label"> Registered: </span>
                  <input type="number" name="registered" required formControlName="registered"
                    placeholder="Registered users" class="form-control">
                  <div class="help-block" *ngIf="registered.invalid && (registered.dirty || registered.touched)">
                    <p class="text-danger">
                      <i class="icon-cancel-circle2 position-left"></i> number of registered people is required
                    </p>
                  </div>
                </div>
              </div>

              <div class="col-md-4">
                <div class="form-group required">
                  <span class="control-label">Status: </span>
                  <select name="status" required formControlName="status" class="form-control"
                    data-placeholder="Select equb status">
                    <option selected disabled>Status:</option>
                    <option value="pending">Pending</option>
                    <option value="active">Active</option>
                    <option value="completed">Completed</option>
                  </select>
                  <div class="help-block" *ngIf="status.invalid && (status.dirty || status.touched)">
                    <p class="text-danger">
                      <i class="icon-cancel-circle2 position-left"></i>Equb status is required.
                    </p>
                  </div>
                </div>
              </div>

            </div>

          </fieldset>
        </div>

        <div class="col-md-7">
          <fieldset>
            <legend class="text-semibold">
              <i class="icon-camera position-left"></i> Equb Details <span *ngIf="ekubValue.value">- {{ekubValue.value}}
                ETB - {{total_due.value}} ETB /
                {{mainService.getIntervalFormalStr(category?.value?.interval)}}</span>
            </legend>


            <div class="row">

              <div class="col-md-6">
                <div class="form-group required">
                  <span class="control-label">Bank: </span>
                  <!-- <select name="bank" required formControlName="bank" class="form-control"
                    data-placeholder="Select assigned bank">
                    <option selected disabled>Assigned Bank:</option>
                    <option value="cbe">CBE</option>
                    <option value="boa">BOA</option>
                  </select> -->
                  <ng-select [items]="banks" placeholder="" formControlName="bank" bindLabel="title"
                    (change)="getBankAccounts(bank.value.accronym)" required>
                  </ng-select>
                  <div class="help-block" *ngIf="bank.invalid && (bank.dirty || bank.touched)">
                    <p class="text-danger">
                      <i class="icon-cancel-circle2 position-left"></i>Assigned Bank is required.
                    </p>
                  </div>
                </div>
              </div>

              <div class="col-md-6">
                <div class="form-group required">
                  <span class="control-label">Account Number: </span>
                  <!-- <input type="text" name="account_no" formControlName="account_no"
                    placeholder="Assigned bank account number" class="form-control"> -->
                  <ng-select [items]="accounts" placeholder="" formControlName="account" bindLabel="title" required>
                  </ng-select>
                  <div class="help-block" *ngIf="account.invalid && (account.dirty || account.touched)">
                    <p class="text-danger">
                      <i class="icon-cancel-circle2 position-left"></i>Bank account number is required.
                    </p>
                  </div>
                </div>
              </div>

              <div class="col-md-12">

                <div class="form-group">
                  <label>&nbsp;</label>
                  <label>Remark:</label>
                  <textarea rows="5" cols="5" class="form-control" name="remark" formControlName="remark"
                    placeholder="Additional information . . ." required></textarea>
                  <div class="help-block" *ngIf="remark.invalid && (remark.dirty || remark.touched)">
                    <p class="text-danger">
                      <i class="icon-cancel-circle2 position-left"></i>Please write small description about the equb
                    </p>
                  </div>
                </div>
              </div>

            </div>

          </fieldset>
        </div>

      </div>

      <div class="text-right">

        <!--  <button class="btn bg-slate-800" (click)="addNews(ekub.id)" type="submit" data-style="slide-right" [ladda]="isLoading" [disabled]="newsForm.invalid">
          <span *ngIf="!ekub.id">Save News</span>
          <span *ngIf="ekub.id">Update News</span>
          <i class="icon-floppy-disk position-right"></i>
        </button> -->
        <button class="btn bg-slate-800" (click)="addEkub()" type="submit" data-style="slide-right"
          [disabled]="ekubForm.invalid">
          <span *ngIf="operation=='add'">Save Equb</span>
          <span *ngIf="operation!='add'">Update Equb</span>
          <i class="icon-floppy-disk position-right"></i>
        </button>

      </div>



    </div>
  </div>
</form>
<!-- /2 columns form -->